import { render, staticRenderFns } from "./Question394.vue?vue&type=template&id=2f185bf2&scoped=true&"
import script from "./Question394.vue?vue&type=script&lang=js&"
export * from "./Question394.vue?vue&type=script&lang=js&"
import style0 from "./Question394.vue?vue&type=style&index=0&id=2f185bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f185bf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
